module.exports = __webpack_public_path__ + "static/media/charbel.4acbfa07.jpeg";